import moment from 'moment';

type ModifiedCellProps = {
  modifiedAt: Date;
};

export const ModifiedCell = ({ modifiedAt }: ModifiedCellProps) => {
  return <span>{moment(modifiedAt).format('D MMM YYYY').toLowerCase()}</span>;
};
